import { atom } from 'recoil';

export const dmsCommandsFetchingAtom = atom<boolean>({
  key: 'dmsCommandsFetching',
  default: false,
});
